<template>

    <b-modal :id="`bv-modal-change-category-${page}`" hide-footer>

      <template #modal-title>Change category</template>

      <div class="text-center" v-if="product.images">
            <span v-if="product.images.length > 0">
                <img v-if="product.images[0].url" :src="product.images[0].url" class="product_image" />
                <img v-else :src="product.images[0]" class="product_image" />
            </span>
            <img v-else class="product_image" src="/images/image-not-found.svg" />
        </div>

      <div class="pt-2 pb-3 text-center"><b>{{product.name}}</b></div>

      <v-select
        :clearable="false"
        v-model.trim="product.sub_category"
        class="select-box"
        :options="subCategories"
        label="name">
        <template #option="{ name }">
          <span>{{ name }}</span>
        </template>
      </v-select>

      <div class="row pt-3 pb-2">
        <div class="col">
            <button type="button" class="btn btn-dark col" @click="hideModalChangeCategory()">Cancel</button>
        </div>
        <div class="col">
            <button v-if="updating" type="button" class="btn btn-success col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-success col" @click="saveEmail">Save</button>
        </div>
      </div> 

    </b-modal>

</template> 

<script>
export default {
  props: ['product','page'],

  data() {
    return {
      updating: false,
      content: null,
      subCategories: [],
    };
  },

    created() {
        this.getSubCategories();
    },

  methods: {

    getSubCategories() {
      axios.get('/products/sub-categories')
        .then((response) => {
          this.subCategories = response.data;
        });
    },

    clearContent() {
      this.content = null;
    },

    hideModalChangeCategory() {
      this.$bvModal.hide(`bv-modal-change-category-${this.page}`);
    },

            saveEmail() {

              if (this.product.sub_category == null || this.product.sub_category == '') {this.sweetfire('Please select a category')}

            else {

              this.updating = true;

              axios.post('/products/update-category', {
                product: this.product})
                .then((response) => {

                  if (response.data.success) {
                    this.hideModalChangeCategory();
                    this.successAlert(response.data.message);
                  } else {
                    this.sweetfire(response.data.message);
                  }

                  this.updating = false;

                });

          }

      },

      successAlert(text) {

        Swal.fire({
            title: text,
            customClass: {
                title: "popup-title",
                icon: 'custom-icon-size'
            },
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: { title: "popup-title" },
    })

    },
  },
};
</script>

<style scoped>
.product_image { height:3rem; }
</style>